import { compressionAdapts } from './file-type.dataset.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import _ from 'lodash';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { FormatDatasetAdapter } from 'app/model/adapters/datasets/format-dataset.adapter';
import { BinaryDataset } from 'app/model/dataset/binary.dataset';
import { GlobalVariables } from 'app/services/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(BinaryDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            parameters: '*',
            type: '*',
            linkedServiceName: '*',
            linkedService: '*',
            connectionSettings: __IS_FABRIC_DPE__ ? '*' : undefined,
            connectionProperties: GlobalVariables.disableServerCertificate ? '*' : undefined,
            typeProperties: {
                location: '*',
                compression: compressionAdapts
            }
        }
    }
})
export class BinaryDatasetAdapter extends FormatDatasetAdapter<BinaryDataset, Model.DatasetV2Resource> {
    protected async _toResource(dataset: BinaryDataset): Promise<Model.DatasetV2Resource> {
        const modelDatasetResource = await super._toResource(dataset) as Model.DatasetV2Resource;
        const modelDataset = this.properties(modelDatasetResource) as Model.BinaryDataset;
        modelDataset.type = Metamodel.modelFor(BinaryDataset).name;
        modelDataset.typeProperties = modelDataset.typeProperties || {};
        if (dataset.location) {
            modelDataset.typeProperties.location = this.locationToResource(dataset);
        }
        const compressionType = ValueAdapter.toResource(dataset, BinaryDataset.COMPRESSION_CODEC);
        if (compressionType) {
            modelDataset.typeProperties.compression = {
                type: compressionType,
                level: ValueAdapter.toResource(dataset, BinaryDataset.COMPRESSION_LEVEL)
            };
        }
        if (dataset.raw) {
            const parsed = JSON.parse(dataset.raw);
            _.merge(modelDatasetResource, parsed);
        }
        return modelDatasetResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetV2Resource, dataset?: BinaryDataset): Promise<BinaryDataset> {
        if (!dataset) {
            dataset = BinaryDataset.MODEL.create<BinaryDataset>(modelDatasetResource.name);
        }
        await super._toModel(modelDatasetResource, dataset);
        if (modelDatasetResource
            && modelDatasetResource.properties
            && modelDatasetResource.properties.typeProperties
            && modelDatasetResource.properties.typeProperties.location) {
            await this.locationToModel(modelDatasetResource, dataset);
        }

        if (modelDatasetResource
            && modelDatasetResource.properties
            && modelDatasetResource.properties.typeProperties) {
            const typeProps = modelDatasetResource.properties.typeProperties as Model.BinaryDatasetTypeProperties;
            if (typeProps.compression) {
                ValueAdapter.toModel(dataset, BinaryDataset.COMPRESSION_CODEC, typeProps.compression.type);
                ValueAdapter.toModel(dataset, BinaryDataset.COMPRESSION_LEVEL, typeProps.compression.level);
            }
        }

        dataset.raw = JSON.stringify(await ValueAdapter.remainder(this.context, modelDatasetResource, BinaryDataset.MODEL));
        return dataset;
    }
}
